import { render, staticRenderFns } from "./subject_frequency.vue?vue&type=template&id=76b48a71&scoped=true&"
import script from "./subject_frequency.vue?vue&type=script&lang=js&"
export * from "./subject_frequency.vue?vue&type=script&lang=js&"
import style0 from "./subject_frequency.vue?vue&type=style&index=0&id=76b48a71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b48a71",
  null
  
)

export default component.exports